import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { environment } from '../../../environments/environment';
import { BackLinkComponent } from '../../shared/components/back-link/back-link.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { LoadingSpinnerComponent } from '../../shared/components/loading-spinner/loading-spinner.component';
import { ResizableTextareaComponent } from '../../shared/components/resizable-textarea/resizable-textarea.component';

interface Setting {
  key: string;
  value: string;
  description: string;
}

@Component({
  selector: 'app-prompt-snippets',
  templateUrl: './prompt-snippets.component.html',
  styleUrls: ['./prompt-snippets.component.scss'],
  standalone: true,
  imports: [
    CommonModule, RouterModule, FormsModule,
    MatButtonModule, MatProgressSpinnerModule,
    BackLinkComponent, PageHeaderComponent, LoadingSpinnerComponent, ResizableTextareaComponent
  ],
})
export class PromptSnippetsComponent implements OnInit {
  isLoading = true;
  isSaving = false;
  successMessage: string | null = null;
  errorMessage: string | null = null;

  userProfile = '';
  knownWaters = '';
  rules = '';

  constructor(
    private http: HttpClient, 
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadSettings();
  }

  private loadSettings(): void {
    this.isLoading = true;
    this.http.get<Setting[]>(`${environment.apiUrl}/settings`).subscribe({
      next: (data) => {
        const userProfileSetting = data.find(s => s.key === 'USER_PROFILE');
        const knownWatersSetting = data.find(s => s.key === 'KNOWN_WATERS');
        const rulesSetting = data.find(s => s.key === 'RULES');

        if (userProfileSetting) this.userProfile = userProfileSetting.value;
        if (knownWatersSetting) this.knownWaters = knownWatersSetting.value;
        if (rulesSetting) this.rules = rulesSetting.value;

        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.errorMessage = 'Failed to load prompt snippets.';
        this.isLoading = false;
        this.cdr.detectChanges();
      },
    });
  }

  saveAll(): void {
    this.isSaving = true;
    this.successMessage = null;
    this.errorMessage = null;

    const requests = [
      this.http.put(`${environment.apiUrl}/settings/USER_PROFILE`, { value: this.userProfile, description: 'User profile used in all system prompts.' }),
      this.http.put(`${environment.apiUrl}/settings/KNOWN_WATERS`, { value: this.knownWaters, description: 'List of known waters used in all system prompts.' }),
      this.http.put(`${environment.apiUrl}/settings/RULES`, { value: this.rules, description: 'User specific rules used in all system prompts.' })
    ];

    Promise.all(requests.map(req => new Promise((resolve, reject) => {
      req.subscribe({
        next: resolve,
        error: reject
      });
    }))).then(() => {
      this.successMessage = 'Prompt snippets saved successfully.';
    }).catch(() => {
      this.errorMessage = 'Failed to save some prompt snippets.';
    }).finally(() => {
      this.isSaving = false;
      this.cdr.detectChanges();
    });
  }
}
